import SystemConfiguration from './SystemConfiguration';
export default SystemConfiguration;